import {
  EmphasizeModuleColor,
  GeneralModuleColor,
  SplitCtaColor,
} from 'constants/ColorScheme';
import { CarouselItem, CarouselModule } from 'types';

export default (
  color: GeneralModuleColor | EmphasizeModuleColor | SplitCtaColor,
  items: CarouselItem[]
): CarouselModule => {
  return {
    type: 'carousel',
    id: 'default-carousel',
    moduleHeader: {
      title: '',
      description: '',
    },
    moduleOptions: {
      color: color,
      showBorderTop: false,
      showBorderBottom: false,
      callout: {
        isActive: false,
        color: 'BLUE',
        infoSectionIsActive: false,
        variant: 'right',
        infoSectionImage: {
          id: '',
          src: '',
          alt: '',
          crop: null,
          hotspot: null,
          metadata: null,
        },
        infoSectionText: [],
        supportingSectionImage: {
          id: '',
          src: '',
          alt: '',
          crop: null,
          hotspot: null,
          metadata: null,
        },
        supportingSectionText: [],
      },
    },
    carouselItems: items,
  };
};
